import { like_api_reaction_url } from "@/mk/urls/functions";

export function saveReaction(xhr, entity, id, emojiType: string | null) {
    return xhr.post(like_api_reaction_url(entity, id), { emojiType });
}
